import React, { useState } from "react";
import styled from "styled-components";
import FlavorPicker from "./flavorPicker";
import SizePicker from "./sizePicker";
import ToppingsPicker from "./toppingsPicker";
import TextToAdd from "./textToAdd";
import AccessoriesPicker from "./edibleAccessoriesPicker";
import TempCake from "./tempCake";
import Data from "../../../../_data";
const CakeCreator = ({ setIsCreating, isCreating }) => {
  const [stage, setStage] = useState(0);
  const [size, setSize] = useState(0);

  const [flavor, setFlavor] = useState({});
  const [toppings, setToppings] = useState([]);
  const [accessories, setAccessories] = useState([]);
  const [textToAdd, setTextToAdd] = useState("");
  const [freezeProgress, setFreezeProgress] = useState(true);
  const [isPhotoRequired, setIsPhotoRequired] = useState(false);

  const moveNext = () => {
    if ((stage < 4) & !freezeProgress) {
      setStage((prev) => prev + 1);
    }
  };
  const moveBack = () => {
    if ((stage > 0) & !freezeProgress) {
      setStage((prev) => prev - 1);
    }
  };

  const pickers = [
    <SizePicker
      size={size}
      setSize={setSize}
      setFreezeProgress={setFreezeProgress}
    />,
    <FlavorPicker
      setFlavor={setFlavor}
      flavor={flavor}
      allFlavors={Data.flavors}
      setFreezeProgress={setFreezeProgress}
    />,
    <ToppingsPicker
      setToppings={setToppings}
      toppings={toppings}
      allToppings={Data.toppings}
      setFreezeProgress={setFreezeProgress}
    />,
    <AccessoriesPicker
      setAccessories={setAccessories}
      accessories={accessories}
      allAccessories={Data.edibleAccessories}
      setFreezeProgress={setFreezeProgress}
    />,
    <TextToAdd textToAdd={textToAdd} setTextToAdd={setTextToAdd} />,

    ,
    "Photo",
  ];
  return (
    <Creator>
      {isCreating && (
        <>
          {pickers[stage]}
          <div className="navigator">
            {stage !== 0 && (
              <button className="nav" onClick={moveBack}>
                Back
              </button>
            )}
            {stage === 4 ? (
              <button className="nav" onClick={() => setIsCreating(false)}>
                Create
              </button>
            ) : (
              <button className="nav" onClick={moveNext}>
                Next
              </button>
            )}
          </div>
          <div className="seperator"></div>
        </>
      )}
      <TempCake
        flavor={flavor}
        size={size}
        toppings={toppings}
        accessories={accessories}
        textToAdd={textToAdd}
      />
    </Creator>
  );
};

export default CakeCreator;

const Creator = styled.div`
  display: flex;
  flex-direction: column;
  /* align-items: center;
  justify-content: center; */
  /* min-height: 85vh; */
  gap: 30px;
  .navigator {
    display: flex;
    width: 100%;
    gap: 20px;
    justify-content: center;
    align-items: center;
  }
  .seperator {
    border-bottom: 1px solid;
    width: 90vw;
    height: 2px;
    opacity: 30%;
  }
  .nav {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    border: none;
    background: none;
    width: 100%;
    background-color: #a3705f;
    border-radius: 7px;
    height: 40px;
    color: #f2e6e2;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
  }
`;
